import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/student/en.json';
import es from '@/locales/student/es.json';
import { getStoredStudentLocale, type StudentLocale } from '@/constants/studentLocale';

const resources = {
  en: { translation: en },
  es: { translation: es },
} as const;

export const studentI18n = i18n.createInstance();

void studentI18n.use(initReactI18next).init({
  resources,
  lng: getStoredStudentLocale(),
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export function setStudentDocumentLang(locale: StudentLocale): void {
  document.documentElement.lang = locale === 'en' ? 'en' : 'es';
}
